// extracted by mini-css-extract-plugin
export var columnList = "_dv-0";